<div class="ne-page">
  <!-- ── TOP NAV ─────────────────────────────────────────── -->
  <div class="ne-topnav">
    <button class="ne-back" (click)="voltar()">
      <i class="fas fa-arrow-left"></i> Escalas
    </button>
    <div class="ne-title-wrap">
      <h1 class="ne-title">Nova Escala</h1>
      <span class="ne-subtitle"
        >Configure cliente, posto, período e seleccione os efetivos</span
      >
    </div>
  </div>

  <!-- ── STEPPER ──────────────────────────────────────────── -->
  <div class="ne-stepper">
    <ng-container *ngFor="let s of steps; let i = index">
      <div
        class="ne-step"
        [class.active]="activeStep === i"
        [class.completed]="activeStep > i"
        (click)="goToStep(i)"
      >
        <div class="ns-node">
          <i class="pi pi-check" *ngIf="activeStep > i"></i>
          <span *ngIf="activeStep <= i">{{ i + 1 }}</span>
        </div>
        <span class="ns-label">{{ s.label }}</span>
      </div>
      <div
        class="ns-connector"
        *ngIf="i < steps.length - 1"
        [class.done]="activeStep > i"
      ></div>
    </ng-container>
  </div>

  <!-- ── STEP CONTENT ─────────────────────────────────────── -->
  <div class="ne-body">
    <!-- ── PASSO 0: CLIENTE ─────────────────────────────── -->
    <div class="ne-step-panel" *ngIf="activeStep === 0">
      <div class="step-card">
        <div class="step-card-header">
          <i class="fas fa-building"></i>
          <div>
            <h2 class="step-card-title">Seleccionar Cliente</h2>
            <p class="step-card-desc">
              Pesquise e seleccione o cliente associado à escala
            </p>
          </div>
        </div>

        <div class="form-group">
          <label>Cliente <span class="req">*</span></label>
          <p-autoComplete
            [formControl]="clienteSearchCtrl"
            [suggestions]="clientesFiltrados"
            optionLabel="nome"
            [delay]="200"
            [minLength]="0"
            placeholder="Pesquisar cliente por nome ou NIF..."
            styleClass="w-full"
            appendTo="body"
            (completeMethod)="pesquisarClientes($event)"
            (onSelect)="selecionarCliente($event)"
            (onClear)="limparCliente()"
          >
            <ng-template pTemplate="item" let-c>
              <div class="cliente-opt">
                <div class="co-info">
                  <span class="co-nome">{{ c.nome }}</span>
                  <span class="co-nif" *ngIf="c.nif">NIF: {{ c.nif }}</span>
                </div>
                <span class="co-sector" *ngIf="c.sector">{{ c.sector }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>

        <!-- Card de confirmação do cliente seleccionado -->
        <div class="selected-card" *ngIf="clienteSelecionado">
          <div class="sc-icon sc-icon-primary">
            <i class="fas fa-building"></i>
          </div>
          <div class="sc-body">
            <span class="sc-title">{{ clienteSelecionado.nome }}</span>
            <span class="sc-meta">
              <span *ngIf="clienteSelecionado.nif"
                >NIF: {{ clienteSelecionado.nif }}</span
              >
              <span *ngIf="clienteSelecionado.numTelefone">
                · {{ clienteSelecionado.numTelefone }}</span
              >
            </span>
          </div>
          <i class="ri-check-circle-fill sc-check"></i>
        </div>

        <!-- Lista de clientes recentes se campo vazio -->
        <div
          class="clientes-hint"
          *ngIf="!clienteSelecionado && clientes.length > 0"
        >
          <p class="hint-label">Clientes disponíveis</p>
          <div class="clientes-chips">
            <button
              class="cliente-chip"
              *ngFor="let c of clientes.slice(0, 8)"
              (click)="selecionarClienteChip(c)"
            >
              {{ c.nome }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── PASSO 1: CONTRATO ─────────────────────────────── -->
    <div class="ne-step-panel" *ngIf="activeStep === 1">
      <div class="step-card">
        <div class="step-card-header">
          <i class="fas fa-file-invoice"></i>
          <div>
            <h2 class="step-card-title">Seleccionar Contrato</h2>
            <p class="step-card-desc">
              {{ clienteSelecionado?.nome }} — escolha o contrato activo
            </p>
          </div>
        </div>

        <div *ngIf="loadingContratos" class="loading-hint">
          <i class="fas fa-spinner fa-spin"></i> A carregar contratos...
        </div>

        <div class="contratos-grid" *ngIf="!loadingContratos">
          <div
            class="contrato-card"
            *ngFor="let c of contratos"
            [class.selected]="contratoSelecionado?.id === c.id"
            (click)="selecionarContrato(c)"
          >
            <div class="cc-top">
              <span class="cc-id">Contrato #{{ c.id }}</span>
              <span class="cc-status" [class.ativo]="isContratoActivo(c)">
                {{ isContratoActivo(c) ? "Activo" : "Expirado" }}
              </span>
            </div>
            <div class="cc-datas">
              <i class="ri-calendar-line"></i>
              {{ formatDate(c.inicioContrato) }} →
              {{ formatDate(c.fimContrato) }}
            </div>
            <div class="cc-valor" *ngIf="c.valorMensal">
              <i class="fas fa-dollar-sign"></i>
              {{ c.valorMensal | number: "1.0-0" }} AOA/mês
            </div>
            <div class="cc-postos" *ngIf="c.numPostos">
              <i class="ri-map-pin-2-line"></i> {{ c.numPostos }} posto(s)
            </div>
            <div class="cc-check" *ngIf="contratoSelecionado?.id === c.id">
              <i class="ri-check-circle-fill"></i>
            </div>
          </div>
        </div>

        <div
          class="empty-hint"
          *ngIf="!loadingContratos && contratos.length === 0"
        >
          <i class="fas fa-file-invoice"></i>
          <span>Nenhum contrato encontrado para este cliente</span>
        </div>
      </div>
    </div>

    <!-- ── PASSO 2: POSTO ───────────────────────────────── -->
    <div class="ne-step-panel" *ngIf="activeStep === 2">
      <div class="step-card">
        <div class="step-card-header">
          <i class="ri-map-pin-2-line"></i>
          <div>
            <h2 class="step-card-title">Seleccionar Posto</h2>
            <p class="step-card-desc">
              {{ clienteSelecionado?.nome }} — escolha o posto a escalar
            </p>
          </div>
        </div>

        <div *ngIf="loadingPostos" class="loading-hint">
          <i class="fas fa-spinner fa-spin"></i> A carregar postos...
        </div>

        <div class="postos-grid" *ngIf="!loadingPostos">
          <div
            class="posto-card-sel"
            *ngFor="let p of postos"
            [class.selected]="postoSelecionado?.id === p.id"
            (click)="selecionarPosto(p)"
          >
            <div class="pcs-left">
              <div class="pcs-icon"><i class="ri-map-pin-2-line"></i></div>
              <div class="pcs-info">
                <span class="pcs-nome">{{ p.nome }}</span>
                <span class="pcs-meta">
                  {{ p.codigo }}
                  <span *ngIf="p.nomeMunicipio"> · {{ p.nomeMunicipio }}</span>
                </span>
              </div>
            </div>
            <div class="pcs-right">
              <app-status-badge
                [value]="p.risco || ''"
                type="risco"
              ></app-status-badge>
              <span class="pcs-ef" *ngIf="p.numEfetivosTurno"
                >{{ p.numEfetivosTurno }} ef/turno</span
              >
            </div>
            <div class="pcs-check" *ngIf="postoSelecionado?.id === p.id">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>

        <div class="empty-hint" *ngIf="!loadingPostos && postos.length === 0">
          <i class="fas fa-map-marker-alt"></i>
          <span>Nenhum posto encontrado para este cliente</span>
        </div>
      </div>
    </div>

    <!-- ── PASSO 3: PERÍODO ─────────────────────────────── -->
    <div class="ne-step-panel" *ngIf="activeStep === 3">
      <div class="step-card">
        <div class="step-card-header">
          <i class="ri-calendar-line"></i>
          <div>
            <h2 class="step-card-title">Período e Cobertura</h2>
            <p class="step-card-desc">
              Configure as datas e tipo de turno da escala
            </p>
          </div>
        </div>

        <!-- Resumo contextual -->
        <div class="ctx-summary">
          <div class="ctx-item" *ngIf="clienteSelecionado">
            <i class="fas fa-building"></i>
            <span>{{ clienteSelecionado.nome }}</span>
          </div>
          <i class="ri-arrow-right-s-line ctx-sep" *ngIf="postoSelecionado"></i>
          <div class="ctx-item" *ngIf="postoSelecionado">
            <i class="ri-map-pin-2-line"></i>
            <span>{{ postoSelecionado.nome }}</span>
          </div>
        </div>

        <form [formGroup]="form" class="periodo-form">
          <!-- Período -->
          <div class="form-grid-2">
            <div class="form-group">
              <label>Data de Início <span class="req">*</span></label>
              <small class="field-help">Primeiro dia em que a equipa fica escalada.</small>
              <p-datepicker
                formControlName="dataInicio"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                styleClass="w-full" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
              <small
                class="ne-err"
                *ngIf="
                  form.get('dataInicio')?.invalid &&
                  form.get('dataInicio')?.touched
                "
                >Obrigatório</small
              >
            </div>
            <div class="form-group">
              <label>Data de Fim <span class="req">*</span></label>
              <small class="field-help">Último dia abrangido por esta escala.</small>
              <p-datepicker
                formControlName="dataTermino"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [minDate]="form.get('dataInicio')?.value"
                styleClass="w-full" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
              <small
                class="ne-err"
                *ngIf="
                  form.get('dataTermino')?.invalid &&
                  form.get('dataTermino')?.touched
                "
                >Obrigatório</small
              >
            </div>
          </div>

          <!-- Cobertura -->
          <div class="form-group">
            <label>Cobertura <span class="req">*</span></label>
            <small class="field-help">
              Escolha a faixa horária que melhor descreve a cobertura do posto.
            </small>
            <div class="cob-toggle">
              @for (opt of coberturaOpts; track opt.value) {
                <button
                  type="button"
                  class="cob-btn"
                  [class.active]="form.get('cobertura')?.value === opt.value"
                  (click)="setCobertura(opt.value)"
                >
                  <i [class]="opt.icon"></i>
                  <span class="cob-btn__label">{{ opt.label }}</span>
                  <span class="cob-btn__desc">{{ opt.desc }}</span>
                </button>
              }
            </div>
          </div>

          <!-- Turno -->
          <div class="form-group">
            <label>Turno <span class="req">*</span></label>
            <small class="field-help">
              O turno define o horário operacional enviado para a API.
            </small>
            <div *ngIf="loadingDropdowns" class="loading-hint">
              <i class="fas fa-spinner fa-spin"></i> A carregar turnos...
            </div>
            <div class="ef-turno-grid" *ngIf="!loadingDropdowns">
              <button
                type="button"
                class="ef-turno-card"
                *ngFor="let t of turnos"
                [class.active]="form.get('turnoId')?.value === t.id"
                (click)="form.get('turnoId')?.setValue(t.id)"
              >
                <i class="fas fa-clock t-icon"></i>
                <span class="t-nome">{{ t.designacao }}</span>
                <span class="t-horas" *ngIf="t.horaInicio && t.horaFim">
                  {{ t.horaInicio?.slice(0, 5) }} – {{ t.horaFim?.slice(0, 5) }}
                </span>
                <i
                  class="ri-check-circle-fill t-check"
                  *ngIf="form.get('turnoId')?.value === t.id"
                ></i>
              </button>
            </div>
            <small
              class="ne-err"
              *ngIf="
                form.get('turnoId')?.invalid && form.get('turnoId')?.touched
              "
            >
              Seleccione um turno
            </small>
          </div>

          <!-- Substituição -->
          <div class="ne-check-row">
            <p-checkbox
              formControlName="escalaSubstituicao"
              [binary]="true"
              inputId="sub"
            ></p-checkbox>
            <label for="sub">
              <i class="ri-swap-line"></i>
              Esta escala é uma substituição temporária
            </label>
          </div>
        </form>
      </div>
    </div>

    <!-- ── PASSO 4: EFETIVOS ───────────────────────────── -->
    <div class="ne-step-panel ne-step-efetivos" *ngIf="activeStep === 4">
      <!-- Mini-resumo contextual -->
      <div class="ef-ctx-bar" *ngIf="postoSelecionado">
        <span
          ><i class="ri-map-pin-2-line"></i> {{ postoSelecionado.nome }}</span
        >
        <span class="ctx-dot">·</span>
        <span
          *ngIf="
            form.get('dataInicio')?.value && form.get('dataTermino')?.value
          "
        >
          <i class="ri-calendar-line"></i>
          {{ form.get("dataInicio")?.value | date: "dd/MM/yy" }} →
          {{ form.get("dataTermino")?.value | date: "dd/MM/yy" }}
        </span>
        <span class="ctx-dot">·</span>
        <span><i class="fas fa-clock"></i> {{ coberturaLabel }}</span>
      </div>

      <!-- Efetivos section -->
      <div class="ne-efetivos" (click)="$event.stopPropagation()">
        <div class="ef-section-intro">
          <div>
            <span class="ef-eyebrow">Composição da equipa</span>
            <h2>Seleccione os efetivos</h2>
            <p>
              Clique num cartão para adicionar o efetivo. O papel inicial será
              <strong>Efetivo</strong> e pode ser alterado no ícone de edição.
            </p>
          </div>
          <div class="ef-selection-badge">
            <i class="ri-team-line"></i>
            <span><strong>{{ selectedEfetivos.length }}</strong> seleccionados</span>
          </div>
        </div>

        <div class="ne-ef-header">
          <div class="ne-search-field">
            <label for="pesquisaEfetivo">Pesquisar efetivo</label>
            <span class="field-help">Filtre pelo nome ou número do BI.</span>
            <div class="ne-ef-search">
              <input
                id="pesquisaEfetivo"
                class="ne-search-input"
                [(ngModel)]="filtroNome"
                (ngModelChange)="onFiltroNomeChange()"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Nome ou número do BI..."
              />
              <i class="fas fa-search" aria-hidden="true"></i>
            </div>
          </div>
          <div class="ne-ef-actions">
            <span class="ne-ef-count">
              <strong>{{ selectedEfetivos.length }}</strong> de
              {{ efetivos.length }} seleccionados
            </span>
            <button
              class="ne-link-btn danger"
              (click)="clearAll()"
              *ngIf="selectedEfetivos.length > 0"
            >
              Limpar
            </button>
          </div>
        </div>

        <!-- Skeleton -->
        <div *ngIf="loadingEfetivos" class="ef-grid">
          <div
            class="ef-card ef-skeleton"
            *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
          >
            <div class="ef-card__avatar ef-skeleton-av"></div>
            <div class="ef-card__info">
              <div class="ef-skel-line" style="width: 70%"></div>
              <div class="ef-skel-line" style="width: 50%"></div>
            </div>
          </div>
        </div>

        <div *ngIf="!loadingEfetivos" class="ef-grid">
          @for (e of efetivosPaginados; track e.id) {
            <div
              class="ef-card"
              [class.selected]="e.selected"
              (click)="toggleEfetivo(e)"
            >
              <div class="ef-card__check">
                <div class="ef-checkbox" [class.checked]="e.selected">
                  <i class="fas fa-check" *ngIf="e.selected"></i>
                </div>
              </div>
              <div class="ef-card__avatar" [class.av-selected]="e.selected">
                <img
                  *ngIf="e.urlFotografia"
                  [src]="e.urlFotografia"
                  [alt]="e.nome"
                  class="ef-avatar-img"
                />
                <span *ngIf="!e.urlFotografia">{{ getInitials(e.nome) }}</span>
              </div>
              <div class="ef-card__info">
                <span class="ef-card__nome">{{ e.nome }}</span>
                <span class="ef-card__bi">BI: {{ e.numBI }}</span>
                <span class="ef-card__status">
                  <span class="dot dot-ativo" *ngIf="e.ativo"></span>
                  <span class="dot dot-inativo" *ngIf="!e.ativo"></span>
                  {{ e.ativo ? "Activo" : "Inactivo" }}
                </span>
                <div class="ef-card__config" *ngIf="e.selected && e.config">
                  <span class="ef-cfg-tag papel">
                    <i class="ri-user-settings-line"></i>
                    {{ getPapelLabel(e.config.papelEfetivoEscalaEnum) }}
                  </span>
                  <button
                    class="ef-edit-btn"
                    (click)="$event.stopPropagation(); abrirConfigEfetivo(e)"
                    title="Alterar papel na escala"
                    aria-label="Alterar papel de {{ e.nome }}"
                  >
                    <i class="fas fa-pen"></i>
                  </button>
                </div>
              </div>
              <div class="ef-card__overlay" *ngIf="e.selected">
                <i class="ri-check-double-line"></i>
              </div>
            </div>
          }

          <div class="ef-empty" *ngIf="efetivosFiltered.length === 0">
            <i class="ri-user-search-line"></i>
            <span>Nenhum efetivo encontrado</span>
          </div>
        </div>

        <div
          class="ef-paginator"
          *ngIf="!loadingEfetivos && efetivosFiltered.length > 0"
        >
          <span class="ef-page-label">
            A mostrar {{ efetivosPaginados.length }} de
            {{ efetivosFiltered.length }} efetivo(s)
          </span>
          <app-paginator-control
            [first]="efetivosFirst"
            [rows]="efetivosRows"
            [totalRecords]="efetivosFiltered.length"
            [rowsPerPageOptions]="[5, 10, 20, 30]"
            (pageChange)="onEfetivosPageChange($event)"
          ></app-paginator-control>
        </div>
      </div>
    </div>
  </div>

  <!-- ── BOTTOM BAR ────────────────────────────────────────── -->
  <div class="ne-bottom-bar">
    <!-- Resumo à esquerda (último passo) -->
    <div
      class="ne-bottom-summary"
      *ngIf="activeStep === 4 && selectedEfetivos.length > 0"
    >
      <div class="ne-bottom-avatars">
        @for (e of selectedEfetivos.slice(0, 4); track e.id) {
          <div class="nb-av" [title]="e.nome">{{ getInitials(e.nome) }}</div>
        }
        <div class="nb-av more" *ngIf="selectedEfetivos.length > 4">
          +{{ selectedEfetivos.length - 4 }}
        </div>
      </div>
      <span class="ne-bottom-text">
        <strong>{{ selectedEfetivos.length }}</strong> efetivo(s) ·
        {{ postoSelecionado?.nome || "Sem posto" }} ·
        {{ coberturaLabel }}
      </span>
    </div>
    <div
      class="ne-bottom-empty"
      *ngIf="activeStep !== 4 || selectedEfetivos.length === 0"
    >
      <span class="step-indicator"
        >Passo {{ activeStep + 1 }} de {{ steps.length }} —
        {{ steps[activeStep].label }}</span
      >
    </div>

    <div class="ne-bottom-btns">
      <button class="btn-web-secondary" (click)="voltar()" [disabled]="submitting">
        <i class="fas fa-times"></i> Cancelar
      </button>
      <button
        class="btn-web-secondary"
        (click)="prevStep()"
        *ngIf="activeStep > 0"
        [disabled]="submitting"
      >
        <i class="fas fa-arrow-left"></i> Anterior
      </button>
      <button
        class="btn-web-primary"
        (click)="nextStep()"
        *ngIf="activeStep < steps.length - 1"
      >
        Próximo <i class="fas fa-arrow-right"></i>
      </button>
      <button
        class="btn-primary ne-submit"
        (click)="save()"
        *ngIf="activeStep === steps.length - 1"
        [disabled]="submitting || !canSubmit()"
      >
        <i *ngIf="submitting" class="fas fa-spinner fa-spin"></i>
        <i *ngIf="!submitting" class="fas fa-calendar-check"></i>
        {{
          submitting
            ? "A criar..."
            : "Criar " + (selectedEfetivos.length || "") + " Escala(s)"
        }}
      </button>
    </div>
  </div>
</div>

<!-- ── PER-EFETIVO CONFIG DIALOG ─────────────────────────── -->
<p-drawer
  [(visible)]="showEfetivoConfigDialog"
  position="right"
  [modal]="true"
  [closable]="true"
  (onHide)="cancelarConfigEfetivo()"
  [style]="{ width: '540px', maxWidth: '95vw' }"
  styleClass="ef-config-dialog efetivo-drawer-dark"
>
  <ng-template pTemplate="header">
    <div class="ef-dlg-header">
      <div class="ef-dlg-photo">
        <img
          *ngIf="efetivoEmConfiguracao?.urlFotografia"
          [src]="efetivoEmConfiguracao!.urlFotografia"
          class="ef-dlg-foto-img"
        />
        <div
          *ngIf="!efetivoEmConfiguracao?.urlFotografia"
          class="ef-dlg-initials"
        >
          {{
            efetivoEmConfiguracao ? getInitials(efetivoEmConfiguracao.nome) : ""
          }}
        </div>
      </div>
      <div class="ef-dlg-info">
        <div class="ef-dlg-nome">{{ efetivoEmConfiguracao?.nome }}</div>
        <div class="ef-dlg-meta-row">
          <span class="ef-dlg-bi"
            ><i class="ri-id-card-line"></i>
            {{ efetivoEmConfiguracao?.numBI }}</span
          >
          <span class="ef-dlg-sep">·</span>
          <span
            class="ef-dlg-status-badge"
            [class.active]="efetivoEmConfiguracao?.ativo"
          >
            <span class="status-dot"></span>
            {{ efetivoEmConfiguracao?.ativo ? "Activo" : "Inactivo" }}
          </span>
        </div>
        <div class="ef-dlg-sub">
          Defina a responsabilidade deste profissional na escala
        </div>
      </div>
    </div>
  </ng-template>

  <div class="ef-config-body" (click)="$event.stopPropagation()">
    <div class="ef-cfg-section">
      <div class="ef-cfg-label">
        <i class="ri-user-settings-line"></i> Papel na escala
        <span class="req">*</span>
      </div>
      <small class="field-help">
        Este valor é enviado em
        <code>papelEfetivoEscalaEnum</code> para o efetivo seleccionado.
      </small>

      <div class="papel-options">
        <button
          type="button"
          class="papel-option"
          *ngFor="let papel of papelEfetivoOpts"
          [class.active]="
            configAtual.papelEfetivoEscalaEnum === papel.value
          "
          (click)="configAtual.papelEfetivoEscalaEnum = papel.value"
        >
          <span class="papel-option__icon">
            <i [class]="papel.icon"></i>
          </span>
          <span class="papel-option__content">
            <strong>{{ papel.label }}</strong>
            <small>{{ papel.desc }}</small>
          </span>
          <i
            class="ri-check-line papel-option__check"
            *ngIf="configAtual.papelEfetivoEscalaEnum === papel.value"
          ></i>
        </button>
      </div>

      <small class="ne-hint">
        <i class="ri-information-line"></i>
        Pode atribuir papéis diferentes aos profissionais da mesma escala.
      </small>
    </div>

    <div class="ef-cfg-preview">
      <div class="ef-cfg-preview__title">
        <i class="fas fa-eye"></i> Resumo do envio
      </div>
      <div class="ef-cfg-preview__tags">
        <span class="ef-prev-tag papel-tag">
          <i class="ri-user-settings-line"></i>
          {{ getPapelLabel(configAtual.papelEfetivoEscalaEnum) }}
        </span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn-web-secondary" (click)="cancelarConfigEfetivo()">
      <i class="fas fa-times"></i> Cancelar
    </button>
    <button class="btn-web-primary" (click)="confirmarEfetivoConfig()">
      <i class="fas fa-check"></i> Confirmar papel
    </button>
  </ng-template>
</p-drawer>
